import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import hotelListing from './hotelListing';
import errorHandler from './errorHandler';
import searchBox from './searchBox';
import checkout from './checkout';
import menubarList from './menubarReducer';
import userinfos from './userInfoReducer';
import hotelDetails from './hotelDetails';
import offers from './offersReducer';
import payment from './paymentReducer';
import thankyou from './thankyou';
import invoice from './invoiceReducer';
import user from './user';
import myBooking from './myBookingReducer';
import bookingAmendment from './bookingAmendmentReducer';
import onloadPopup from './onloadPopupReducer';
import footerData from './footerReducer';
import hotelRecentSearch from './recentSearchReducer';
import hotelRecentBooking from './recentBookingReducer';
import hcnUpdate from './hcnUpdateReducer';

const storeConfig = {
  key: 'hotel',
  storage: storage,
  debug: false,
  whitelist: ['hotelRecentSearch']
};

const rootReducer = persistReducer(storeConfig, combineReducers({
  hotelListing, searchBox,
  checkout, errorHandler,
  menubarList, userinfos,
  hotelDetails, offers,
  payment, thankyou,
  invoice, user,
  myBooking, bookingAmendment,
  onloadPopup, footerData,
  hotelRecentSearch,
  hotelRecentBooking, hcnUpdate
}));

export default rootReducer;
